<template>
	<Card >
		<div style="display: flex; justify-content: space-between;">
			<div>
				<span style="color: #277dd3; margin-right: 10px;cursor: pointer;" class="copy_area"
					:data-clipboard-text="h5Url" @click="copyH5">复制登记页链接</span>
				<!--Button type="primary" @click="addClient">添加客户</Button-->
			</div>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod" @on-change="searchMyTask">
				<Radio label=""><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
					type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">来访人</div>
			<Select v-model="followUid" style="width:150px;" clearable placeholder="跟进人" @on-change="searchMyTask">
				<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<i-input placeholder='搜索客户姓名/手机' @on-change="searchMyTask" v-model="taskTitle" style="width: 300px;margin-left: 30px;">
				<i-button slot="append" icon="ios-search" v-on:click="searchMyTask()"></i-button>
			</i-input>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">来访团队</div>
			<Select v-model="followDepartment" @on-change="searchMyTask" clearable style="width:150px;" placeholder="跟进团队">
				<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
				</Option>
			</Select>
			<Button style="margin-left: 20px;" type="primary" v-on:click="initTask()">重置</Button>
		</div>
		<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
			<Table :columns="columns" :data="myTaskList" size="small" ref="table">
				<template slot-scope="{ row }" slot="name">
					<span class="get_state" @click.stop="edit" :data-id="row.client_id" :data-name="row.name">{{row.name}}</span>
				</template>
				<template slot-scope="{ row }" slot="phone">
					<span v-if="row.follow_uid == null || row.can_get" class="get_state">{{row.phone}}</span>
					<span v-else>{{row.phone | getPhoneNumber}}</span>
				</template>
				<template slot-scope="{ row }" slot="door_time">
					<span :class="{get_state:row.follow_uid == null || row.can_get }">{{row.created_at}}</span>
				</template>
				<template slot-scope="{ row }" slot="belonger">
					<span :class="{get_state:row.follow_uid == null || row.can_get }">{{row.userName}}</span>
				</template>
				<template slot-scope="{ row, index }" slot="action" v-if="userInfo.role_type == 4">
					<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
						@click="editInter">编辑</Button>
					<!--Button type="error" size="small" :data-id="row.id" @click="delClientRecoverSet">删除</Button-->
				</template>
				<!--            <template slot-scope="{ row }" slot="receiptor">-->
				<!--                <span v-if="row.follow_uid !== '' ">{{row.receiptor}}</span>-->
				<!--                <span v-if="row.follow_uid == 'null' " :class="{get_state:row.receiptor == '' }">未领取</span>-->
				<!--            </template>-->
			</Table>
			<div class="pager1">
				<Page show-total :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
					show-elevator />
			</div>			
		</div>
		<Modal v-model="interModal" title="编辑" @on-ok="saveDoorClient">
			<div style="height: 600px; overflow-y: auto; overflow-x: hidden">
				<Form :model="formItem" :label-width="100">
					<FormItem label="姓名">
						<Input v-model="formItem.name">
						</Input>
					</FormItem>
					<FormItem label="登记人">
						<Select v-model="formItem.get_uid">
							<Option v-for="item in userList" :value="item.id" :key="item.id">
								{{ item.name }}[{{item.id+1000}}]
							</Option>
						</Select>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<!-- 选择客户 -->
		<Modal v-model="chooseModal" width="500" title="选择客户">
			<div class="multiple" style="align-items: center">
				<div class="child-div inline-block" style="width: 100px !important;">选择客户</div>
				<Select v-model="clientId" filterable>
					<Option v-for="item in clientList" :value="item.id" :key="item.id">{{ item.name }}{{item.phone}}
					</Option>
				</Select>
			</div>
			<div slot="footer">
				<Button type="primary" @click="sureChoose()">确定</Button>
			</div>
		</Modal>
		<!-- 编辑/新增客户 -->
		<div v-if="editDiv" style="background: #f9fafc;">
			<div style="height:600px;width:100%:">
				<Modal v-model="editModal" width="95%" title="" footer-hide :styles="editModalStyle">
					<EditClue @reloadData="loadData" @beforeOne="beforeEditOne" @nextOne="nextEditOne"
						:id="editClientId"></EditClue>
				</Modal>
			</div>
		</div>
	</Card>
</template>

<script>
	import {
		getH5Url,
		getTodayList,
		getClient,
		getDoorClient,
		saveDoorClient,
		sureChooseClient
	} from '@/api/task'
	import {
		getList
	} from '@/api/client'
	import {
		getUserList,
		getTeamList,
		getDepartmentList,
	} from '@/api/user'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import EditClue from '../client/EditClue.vue';
	import Clipboard from 'clipboard';

	export default {
		name: "TodayCustomer",
		components: {
			EditClue
		},
		computed: {
			...mapGetters(['token','userInfo']),
		},
		props:['follow_uid_props','department_id_props','timePeriod_props','timePeriodDate_props','shop_id'],
		mounted: function() {
			this.loadData();
			this.getList();
		},
		watch: {
			department_id_props() {
				this.followDepartment = this.department_id_props;
				this.followUid = this.follow_uid_props;
				this.timePeriod = this.timePeriod_props;
				this.timePeriodDate = this.timePeriodDate_props;
				this.searchMyTask();
			},
			follow_uid_props() {
				this.followDepartment = this.department_id_props;
				this.followUid = this.follow_uid_props;
				this.timePeriod = this.timePeriod_props;
				this.timePeriodDate = this.timePeriodDate_props;
				this.searchMyTask();
			},
			timePeriod_props() {
				this.followDepartment = this.department_id_props;
				this.followUid = this.follow_uid_props;
				this.timePeriod = this.timePeriod_props;
				this.timePeriodDate = this.timePeriodDate_props;
				this.searchMyTask();
			},
			timePeriodDate_props() {
				this.followDepartment = this.department_id_props;
				this.followUid = this.follow_uid_props;
				this.timePeriod = this.timePeriod_props;
				this.timePeriodDate = this.timePeriodDate_props;
				this.searchMyTask();
			}
		},
		data() {
			return {
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				formItem:{},
				editDiv: false,
				editModal: false,
				editClientId: 0,
				h5Url: '',
				count: 0,
				page: 1,
				taskTitle: '',
				myTaskList: [],
				timePeriod: '0',
				timePeriodDate: [],
				clientList: [],
				registerId: 0,
				clientId: 0,
				interModal:false,
				chooseModal: false,
				columns: [{
						type: 'selection',
						width: 60,
						align: 'center'
					},
					{
						title: '客户姓名',
						slot: 'name',
						align: 'center'
					},
					{
						title: '手机号码',
						slot: 'phone',
						align: 'center'
					},
					{
						title: '上门时间',
						slot: 'door_time',
						align: 'center',
						sortable: true
					},
					{
						title: '当前客户状态',
						key: 'status_name',
						align: 'center'
					},
					{
						title: '登记人',
						slot: 'belonger',
						align: 'center'
					},
					{
						title: '部门',
						key: 'department_name',
						align: 'center'
					},
					{
						title: '备注',
						key: 'remark',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						align: 'center'
					},
				],
				departmentList: [],
				followDepartment: [],
				teamList: [],
				followUid:[],
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			searchMyTask() {
				this.page = 1;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.searchMyTask();
			},
			saveDoorClient() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: that.formItem
					};
					let res = await saveDoorClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						this.getList();
					}
				}, 500)
			},
			async editInter(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getDoorClient(that, data);
				if (res.code == 1) {
					that.formItem = res.data.item;
					that.interModal = true;
				}
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getH5Url(that, data);
				if (res.code == 1) {
					that.h5Url = res.data.h5Url;
				}
				res = await getTeamList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			async getList() {
				let that = this;
				let data = {
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate
				}
				data.name = this.taskTitle;
				data.followDepartment = this.followDepartment;
				data.followUid = this.followUid;
				data.token = this.token;
				data.shop_id = this.shop_id;
				data.page = this.page;
				let res = await getTodayList(that, data);
				that.myTaskList = res.data.list;
				that.count = res.count;
			},
			initTask(){
				this.timePeriodDate = [];
				this.timePeriod = '0';
				this.followUid = [];
				this.followDepartment = [];
				this.taskTitle='';
				this.searchMyTask();
			},
			getClient(e) {
				let id = e.currentTarget.dataset.id;
				let clientId = e.currentTarget.dataset.client_id;
				let that = this;
				this.$Modal.confirm({
					title: '确认领取吗？',
					onOk: async () => {
						var data = {
							token: this.token,
							id: id,
							client_id: clientId
						};
						let res = await getClient(that, data);
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})

			},
			sureChoose() {
				let that = this;
				var data = {
					token: this.token,
					client_id: that.clientId,
					id: that.registerId
				};
				this.throttle(async function() {
					let res = await sureChooseClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.chooseModal = false;
						that.getList();
					}
				}, 500)
			},
			async chooseClient(e) {
				let that = this;
				that.registerId = e.currentTarget.dataset.id;
				let data = {
					menu: 'my_undoor'
				}
				data.name = e.currentTarget.dataset.name;
				data.token = this.token;
				let res = await getList(that, data);
				that.clientList = res.data.list;
				this.chooseModal = true;
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				if(id == null || id == "" || id == 0){
					that.$Message.error('库里不存在该客户')
					return;
				}
				let name = e.name || e.currentTarget.dataset.name;
				this.$nextTick(function() {
					/*
					  that.oldDatas = that.datas;
					  that.editModal = true;
					  */
					this.$router.push({
						name: "newEditClue",
						params: {
							id: id,
							name: name,
							data: that.datas,
						},
					});
				});
			},
			copyH5() {
				let that = this;
				var clipboard = new Clipboard('.copy_area')
				clipboard.on('success', e => {
					that.$Message.success("复制成功");
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					that.$Message.error('该浏览器不支持自动复制')
					clipboard.destroy()
				})
			},
			addClient() {
				let that = this;
				this.clientId = 0;
				this.editDiv = true;
				this.$nextTick(function() {
					that.editModal = true;
				})
			},
			beforeEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			},
			nextEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			}
		},
		filters: {
			getPhoneNumber(phone) {
				const newPhone = phone.substring(0, 3) + '****' + phone.substring(7, 11)
				return newPhone
			},
		}
	}
</script>

<style scoped lang="less">
	.text-center {
		height: 580px;
		overflow: scroll;
	}

	.shijian {
		position: relative;
		left: 15px;
	}

	.xiaoxi {
		position: relative;
		left: -120px;
		top: 18px;
	}

	.icon-biao {
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}

	.xiangqing {
		background-color: #F9FAFA;
	}

	.biaoti {
		font-weight: bold;
	}

	.biaogetoubu {
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}

	.shuju {
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;

		div {
			margin-right: 20px;
			width: 60px;
		}
	}

	.biaogelimian {
		display: flex;
		justify-content: space-around;
	}

	.shanchu {
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}

	.biaotou {
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}



	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}

	.ivu-table-fixed-header thead tr th {
		text-align: center;
	}

	.get_state {
		color: #2C8CF0;
		cursor: pointer;
	}
	.inline-block {
		display: inline-block;
	}
</style>
